// extracted by mini-css-extract-plugin
module.exports = {"module-list":"_5D11lkOV","container":"_5D1IcrdR","card":"_5D2V59qZ","empty":"_5D3nbS2T","news-title":"_5DM8N1Cz","loader":"_5Du27VlJ"};